export default ({ cls = '', gifts, title } = {}) => [
  {block: 'gift-popper', cls, content: [
      {elem: 'title', tag: 'h1', content: title || 'Подарок'},
      {cls: 'custom-scrollbar', content: gifts.map(({ href, src, title: description }) => [
          {elem: 'item', tag: 'a', attrs: {href: href}, content: [
              {elem: 'image', content: [
                  {block: 'img', attrs: {loading: 'lazy'},  src: src}
                ]},
              {elem: 'content', content: [
                  {elem: 'description', content: description},
                ]},
            ]},
        ])},
    ]},
];
